"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  "Choose a rating": "Choisir une évaluation",
  "Click to clear selected rating": "Cliquez pour effacer l’évaluation sélectionnée"
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map